/**
 * Route map for the mobile bottom navigation.
 * Remaps the demo (`ecommerce-mobile`) paths to the main app routes.
 * Demo:  /HomePage /category /More /CartPage /Profile
 * Main:  /HomePage /Categories /Wallet /Cart     /Dashboard
 */
export const MOBILE_NAV_ROUTES = {
  home: "/HomePage",
  categories: "/Categories",
  more: "/Wallet",
  cart: "/Cart",
  profile: "/Dashboard",
} as const;

/** Paths where the mobile bottom nav should be hidden. */
export const MOBILE_NAV_EXCLUDED_PATHS: string[] = [
  "/SignIn",
  "/SignUp",
  "/ForgotPassword",
  "/Checkout",
];
